import { connect } from 'react-redux'
import { reduxForm, destroy, initialize, reset } from 'redux-form'
import { post } from '../modules/customer'

import component from 'components/Customers/New'

const formName = 'new-customer'
const fields = [
  'name', 'notes', 'cc_orders',
  'routes[].day_of_week', 'routes[].id',
  'contacts[].title', 'contacts[].name', 'contacts[].phone_number', 'contacts[].email',
  'address', 'city', 'state', 'postcode'
]

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatch,
  onSubmit: (data) => {
    let initialValues = mapStateToProps({}, ownProps).initialValues

    dispatch(post(data))
    dispatch(reset(formName))
    dispatch(destroy(formName))
    dispatch(initialize(formName, initialValues, fields))
  }
})

const mapStateToProps = (state) => ({
  customer: state.customer,
  routes: state.routes,
  initialValues: {
    routes: [{ day_of_week: undefined, id: undefined }],
    contacts: [{ title: undefined, name: undefined, phone_number: undefined, email: undefined }]
  }
})

const form = reduxForm({
  form: formName,
  fields,
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.name) errors.name = 'Please enter a name for the customer.'

    return errors
  }
})(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/Customers/containers/NewCustomerContainer.js